/*
 *
 *  Login
 *  contains basic js for the contact page
 *  !! Created by Jurgen on 29/08/2017
 *
 */

$(document).ready(function () {
    // LOGIN
    // Initialize strTypeLogin (login | loginpopup)
    if (typeof strTypeLogin === 'undefined') {
        strTypeLogin = "login";
    }

    // login popup
    // Close popup when you are already loggedin
    // if (blnClosePopup) {
    //     parent.$.fancybox.close();
    // }

    // Login
    if ($("form#frmLogin").length > 0) {
        FormValidateLogin($("form#frmLogin"), strTypeLogin);
    } else {
        // Register
        // Remove company fields
        $('ul.form li.company').hide();

        $('li.company').hide();

        // Clicking on 'Particulier' => hide company fields
        $('ul.form li input[id="optVatTypeP"]').on('click', function () {
            $('li.company').slideUp();
            // Remove all errors
            $('li.company input').removeClass('required error');
            $('li.company input').find('label.error').remove();
        });

        // Clicking on 'Bedrijf' => show company fields
        $('ul.form li input[id="optVatTypeB"]').on('click', function () {
            $('li.company').slideDown();
            $('li.company input').addClass('required');
        });

        if (WebsiteSettingBlnUseState) {
            // Change the country
            $('ul.form li select[id="selCountry"]').on('change', function () {
                var strParams = "strCountryCode=" + $(this).val();

                // Get states from the selected country
                $.post(strAjaxPath + "cart/get-state.php", strParams, function (arrObjecten) {
                    var intNumber = Object.keys(arrObjecten).length;

                    if (intNumber > 0) {
                        // Show areas
                        $("li#area-container").removeClass("d-none");
                        $('#selState').find('option').remove();

                        $.each(arrObjecten, function (i, val) {
                            $('#selState').append("<option value='" + val.areacode + "'>" + val.areaname + "</option>");
                        });
                    } else {
                        // Hide areas
                        $("li#area-container").addClass("d-none");
                        $('#selState').find('option').remove();
                    }
                }, "json");
            });
        }

        // Form validate
        if ($("form#frmRegister").length > 0) {
            FormValidateRegister($('form#frmRegister'));

            $('#btnRegister').on("click", function (event) {
                event.preventDefault();
                FormValidateRegister($('form#frmRegister'));
                if ($('form#frmRegister').valid()) {
                    grecaptcha.execute();
                }
            });
        }
    }
});

// // Use login.js
// $.getScript(strPath + 'javascript/default/base/pages/login.js', function () {
//
// });